
module.exports = {
  // TODO: change your profile information here
  name: "Vybhav Reddy",
  greeting: "Welcome to my page 👋",
  greetingDescription: "I'm Vybhav Reddy and I'm a Data Scientist / Software Engineer !!!",
  githubUrl: "https://github.com/vybhavsv",
  linkedinUrl: "https://www.linkedin.com/in/vybhavsv/",
  dsAcademicUrl: "https://eportfolio.greatlearning.in/vybhav-s-v",
  cvLink: "https://drive.google.com/file/d/1ueRZGb2YZ3qeslvF-B3gnRfeX42rY6Vh/view?usp=sharing",
};
